<template>
    <div class="case_card card_bottom-padding caseInfo">
        <el-row class="title_row">
            <el-col :span="12">
                <div class="card_title">
                    诉讼案件详情
                    <el-tag type="warning" style="margin-left: 5px" v-if="caseDetailData && caseDetailData.suspendedFlag">挂起</el-tag>
                </div>
            </el-col>
        </el-row>
        <div class="card_content">
            <el-row>
                <el-col :span="24">
                    <el-row class="content_row">
                        <el-col class="col_title" :span="5">案件名称：</el-col>
                        <el-col class="col_txt" :span="7">{{ caseDetailData && caseDetailData.caseName ? caseDetailData.caseName : '--' }}</el-col>
                        <el-col class="col_txt" :span="10">
                            归档编号：
                            {{ caseDetailData && caseDetailData.filingNumber ? caseDetailData.filingNumber : '--' }}
                        </el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_title" :span="5">法院案号：</el-col>
                        <el-col class="col_txt" :span="7">{{ caseDetailData && caseDetailData.courtCaseNo ? caseDetailData.courtCaseNo : '--' }}</el-col>
                        <el-col class="col_txt" :span="4">
                            <span
                                v-if="caseDetailData && caseDetailData.successRate"
                                :class="{ winRate: 1, redColor: caseDetailData && caseDetailData.successRate && caseDetailData.successRate > 50, greenColor: caseDetailData && caseDetailData.successRate && caseDetailData.successRate <= 50 }"
                            ></span>
                            胜诉率：
                            {{ caseDetailData && caseDetailData.successRate ? caseDetailData.successRate + '%' : '--' }}
                        </el-col>
                        <el-col class="col_txt" :span="6" :offset="4">案件状态：{{ caseDetailData && caseDetailData.checkStatusDesc ? caseDetailData.checkStatusDesc : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7">结案我司承担受理费：{{ caseDetailData && caseDetailData.bearAcceptanceFee && caseDetailData.currentCaseStep == 999 ? caseDetailData.bearAcceptanceFee + ' 元' : '--' }}</el-col>
                        <el-col class="col_title" :span="5"><div style="width: 1px; height: 1px"></div></el-col>
                        <el-col class="col_txt" :span="4">结案法院受理费：{{ caseDetailData && caseDetailData.courtAcceptanceFee && caseDetailData.currentCaseStep == 999 ? caseDetailData.courtAcceptanceFee + ' 元' : '--' }}</el-col>
                        <el-col class="col_txt" :span="4" offset="4">初次委托律师时间：{{ caseDetailData && caseDetailData.firstEntrustTime ? caseDetailData.firstEntrustTime : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" offset="1" v-if="waitingPlan">
                            <span class="waiting-highlight" role="status" aria-live="polite">
                                <span class="waiting-hourglass" aria-hidden="true">⌛</span>
                                <span class="waiting-label">已等待</span>
                                <strong>{{ waitingText }}</strong>
                            </span>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { formatWaitingDuration, getWaitingSeconds } from '@/utils/lawsuitWaiting';
export default {
    props: {
        caseDetailData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            navForm: {
                caseNo: '',
                value1: [],
                value2: [],
                value3: '',
                value4: '',
                value5: '',
                page: 1,
                size: 10,
                total: 0
            },
            waitingNow: Date.now(),
            waitingTimer: null
        };
    },
    computed: {
        waitingPlan() { return this.caseDetailData && this.caseDetailData.casePlans && this.caseDetailData.casePlans[0] && this.caseDetailData.casePlans[0].assignmentMode === 'SELECTED' && this.caseDetailData.casePlans[0].waitStatus === 'WAITING' ? this.caseDetailData.casePlans[0] : null; },
        waitingText() { return formatWaitingDuration(getWaitingSeconds(this.waitingPlan, this.waitingNow)); }
    },
    mounted() { this.waitingTimer = setInterval(() => { this.waitingNow = Date.now(); }, 1000); },
    beforeDestroy() { clearInterval(this.waitingTimer); },
    methods: {},
    watch: {
        caseDetailData: {
            handler(val) {
                if (val) {
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/caseCard.css';
.caseInfo {
    .title_row {
        .btn_groups {
            text-align: right;
        }
    }
    .card_content {
        .content_row {
            .title {
                font-weight: 600;
            }
            .col_title {
                // font-weight: 600;
                max-width: 80px;
            }
            .col_txt {
                line-height: 22px;
                // border: 1px solid red;
            }
            .waiting-highlight {
                display: inline-flex;
                align-items: center;
                min-height: 30px;
                padding: 0 10px;
                border: 1px solid #f3b562;
                border-radius: 15px;
                background: #fff7e8;
                color: #c77700;
                font-size: 15px;
                font-weight: 600;
                white-space: nowrap;
                box-shadow: 0 1px 4px rgba(230, 162, 60, 0.2);
                .waiting-hourglass {
                    margin-right: 5px;
                    font-size: 17px;
                    line-height: 1;
                    animation: waiting-hourglass-pulse 1.5s ease-in-out infinite;
                }
                .waiting-label {
                    margin-right: 4px;
                }
                strong {
                    font-weight: 700;
                }
            }
            .winRate {
                display: inline-block;
                width: 11px;
                height: 11px;
                border-radius: 50%;
                margin-right: 5px;
                position: relative;
                top: 1px;
            }
            .greenColor {
                background: #67c23a;
            }
            .redColor {
                background: red;
            }
        }
    }
}
@keyframes waiting-hourglass-pulse {
    0%, 100% { opacity: 0.65; transform: translateY(0); }
    50% { opacity: 1; transform: translateY(-1px); }
}
</style>
